import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import AppBar from '../../modules/common-modules/navigation/AppBar';
// import Footer from '../themeComponents/Footer';
// import Settings from "../themeComponents/Settings";

import { Typography, Fab, CssBaseline, withWidth } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';

import {
  DRAWER_WIDTH,
  GlobalStyle,
  StyledRoot,
  StyledDrawer,
  StyledAppContent,
  StyledMainContent,
  StyledDivider
} from './styles';

import { isWidthUp } from '@material-ui/core/withWidth';
import { RouteType } from '../../types/routes';
import { Hidden } from '../../types-hack';

type DashboardPropsType = {
  title?: string;
  hasBackButton?: boolean;
  width: 'md' | 'xs' | 'sm' | 'lg' | 'xl';
  sidebarRoutes: RouteType[];
  helpRoute: string;
  sidebarVisible?:boolean;
};

const Dashboard: React.FC<DashboardPropsType> = ({
  children,
  title,
  hasBackButton,
  width,
  sidebarRoutes,
  sidebarVisible,
  helpRoute
}) => {
  const history = useHistory();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  if (sidebarVisible === undefined) sidebarVisible = true

  return (
    <StyledRoot>
      <CssBaseline />
      <GlobalStyle />

      {sidebarVisible && <StyledDrawer>
        <Hidden mdUp implementation="js">
          <Sidebar
            PaperProps={{ style: { width: DRAWER_WIDTH } }}
            variant="temporary"
            open={mobileOpen}
            routes={sidebarRoutes}
            onClose={handleDrawerToggle}
          />
        </Hidden>
        <Hidden smDown implementation="css">
          <Sidebar PaperProps={{ style: { width: DRAWER_WIDTH } }} routes={sidebarRoutes} />
        </Hidden>
      </StyledDrawer>}

      <StyledAppContent>
        <AppBar onDrawerToggle={handleDrawerToggle} helpRoute={helpRoute} />
        <StyledMainContent p={isWidthUp('lg', width) ? 12 : 5}>
          <Helmet title={title} />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h3" gutterBottom display="inline">
              {title}
            </Typography>
            {hasBackButton && (
              <Fab color="primary" size="small" aria-label="Back" onClick={history.goBack}>
                <KeyboardBackspaceIcon />
              </Fab>
            )}
          </div>
          <StyledDivider my={6} />
          {children}
        </StyledMainContent>
        {/* <Footer /> */}
      </StyledAppContent>
      {/* <Settings /> */}
    </StyledRoot>
  );
};

export default withWidth()(Dashboard);
